import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  withStyles,
} from '@material-ui/core'

import { validateEmail, validatePhone } from '../helpers'
import Modal from './Modal'
import InputText from './InputText'


const styles = () => ({
  root: {},
})


const ModalEditUser = ({
  user,
  open,
  classes,
  onClose,
  onSubmit,
  isLoading,
}) => {
  const [email, setEmail] = useState((user && user.email) || '')
  const [phone, setPhone] = useState((user && user.phone && validatePhone(user.phone)) || '')
  const [errorPhone, setErrorPhone] = useState(false)
  const [errorEmail, setErrorEmail] = useState(false)

  const handleChange = func => e => func(e.target.value)
  const isSubmitable = !errorPhone && !errorEmail && (phone || email)
  const handleValidateEmail = () => setErrorEmail(validateEmail(email))
  const handleSubmit = () => onSubmit && onSubmit({
    phone,
    email,
  })

  const handleValidatePhone = () => {
    const validated = validatePhone(phone)

    setErrorPhone(!validated)
    setPhone(validated || phone)
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      cancelLabel="Annuler"
      isLoading={isLoading}
      onSubmit={handleSubmit}
      className={classes.root}
      submitLabel="Enregister"
      title="Modifier l'utilisateur"
      submitDisabled={!isSubmitable}
    >
      <InputText
        margin
        fullWidth
        type="email"
        name="email"
        label="E-mail"
        value={email}
        disabled={isLoading}
        onPressEnter={handleSubmit}
        onBlur={handleValidateEmail}
        onChange={handleChange(setEmail)}
        errorText={errorEmail && 'L\'adresse E-mail est invalide'}
      />

      <InputText
        margin
        fullWidth
        tag="div"
        name="phone"
        value={phone}
        label="Téléphone"
        disabled={isLoading}
        onPressEnter={handleSubmit}
        onBlur={handleValidatePhone}
        onChange={handleChange(setPhone)}
        errorText={errorPhone && 'Le numéro de téléphone est invalide'}
      />
    </Modal>
  )
}

ModalEditUser.propTypes = {
  open: PropTypes.bool,
  user: PropTypes.object,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(ModalEditUser)
